import React from 'react';
import { detailsData } from './detailsData';

const DetailedGuide = ({ selectedCard, onStepSelect, onBack }) => {
  const details = detailsData[selectedCard];
  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      <button onClick={onBack} className="mb-4 text-blue-600">&larr; Back</button>
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        {details.title} - Detailed Guide
      </h2>
      <p className="mb-6 text-gray-700">
        Select a step below to view detailed instructions and sample templates.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {details.steps.map((step, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-lg shadow hover:shadow-md cursor-pointer p-6"
            onClick={() => onStepSelect(index)}
          >
            <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
            <p className="text-gray-600">
              {step.content.length > 80 ? step.content.substring(0, 80) + '...' : step.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailedGuide;
